// Types
import { Box, Flex, Grid, GridItem, HStack, Table, Td, Text, Th, Tr, VStack } from "@chakra-ui/react";
import CustomModal from "../../../shared/Modals/CustomModal";
import { LegalBenefit } from "../../../utils/types";

interface BenefitDefinitionsModalProps {
	benefits: LegalBenefit[];
	isOpen: boolean;
	onContinue(): void;
}

export default function BenefitDefinitionsModal({ benefits, isOpen, onContinue }: BenefitDefinitionsModalProps) {
	return isOpen ? (
		<CustomModal
			isOpen={isOpen}
			isCentered={true}
			contentBorder={true}
			contentPadding={false}
			closeOnOverlayClick={true}
			onCancel={onContinue}
			onContinue={onContinue}
			size="3xl"
			title="Benefit Coverage Details"
			continueText="Okay"
			cancelText=""
			content={
				<VStack>
					{benefits.map((benefit, index) => (
						<Box
							width="100%"
							pb={3}
							borderBottom="2px solid"
							borderColor={index !== benefits.length - 1 ? "gray.300" : "white"}>
							<Text fontSize="xl" fontWeight="500" px={5} py={2}>
								{benefit.benefitTitle}
							</Text>
							<Table>
								<Tr>
									<Th style={styles.label}>Code</Th>
									<Td style={styles.value}>{benefit.matterBillingCode}</Td>
								</Tr>
								<Tr>
									<Th style={styles.label}>Description</Th>
									<Td style={styles.value}>{benefit.matterBenefitDescription}</Td>
								</Tr>
								<Tr>
									<Th style={styles.label}>Limitations</Th>
									<Td style={styles.value}>{benefit.matterLimitations}</Td>
								</Tr>
								<Tr>
									<Th style={styles.label}>Special Instructions</Th>
									<Td style={styles.value}>{benefit.matterSpecialInstructions}</Td>
								</Tr>
								<Tr>
									<Th style={styles.label}>Limits and Payment Parameters</Th>
									<Td style={styles.value}>{benefit.matterPaymentParameters}</Td>
								</Tr>
							</Table>
						</Box>
					))}
				</VStack>
			}
		/>
	) : (
		<></>
	);
}

const styles = {
	label: {
		width: "200px",
		minWidth: "200px",
		fontWeight: "500",
		lineHeight: "18px",
		borderBottom: "none",
		padding: "5px 30px"
	},
	value: {
		borderBottom: "none",
		padding: "5px 30px 5px 5px"
	}
};
